// assets/infinite-scroll.js
// Scroll infinito automático para colecciones Dawn — v4-DEBUG (con logs en consola).
(function () {
  'use strict';
 
  const log = (...a) => console.log('[infinite-scroll]', ...a);
  const err = (...a) => console.error('[infinite-scroll]', ...a);
 
  const container = document.getElementById('ProductGridContainer');
  log('init. container?', !!container);
  if (!container) return;
 
  const PAG_SEL = '.pagination-wrapper, nav.pagination, .pagination';
  const LOADING_LABEL = 'Cargando más productos…';
  const SENTINEL_CLASS = 'infinite-scroll__sentinel';
  const TRIGGER_MARGIN = 800;
  let observer = null;
  let loading = false;
  let lastUrl = null;
 
  const getGrid = () => container.querySelector('#product-grid');
  const findPagination = (root) => root.querySelector(PAG_SEL);
  const pageOf = (href) => {
    const m = (href || '').match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  };
 
  function getNextUrl() {
    const pag = findPagination(container);
    if (!pag) { log('getNextUrl: no encontré paginación con', PAG_SEL); return null; }
 
    const currentEl = pag.querySelector('[aria-current="page"]');
    let currentPage = currentEl ? parseInt((currentEl.textContent || '').trim(), 10) : NaN;
    if (!currentPage) {
      const m = window.location.search.match(/[?&]page=(\d+)/);
      currentPage = m ? parseInt(m[1], 10) : 1;
    }
 
    const links = Array.from(pag.querySelectorAll('a[href]'));
    log('getNextUrl: pagina actual', currentPage, '| hrefs:', links.map((l) => l.getAttribute('href')));
 
    const byNumber = links.find((l) => pageOf(l.getAttribute('href')) === currentPage + 1);
    if (byNumber) return byNumber.getAttribute('href');
 
    const byLabel = pag.querySelector('a[rel="next"], a[aria-label*="next" i], a[aria-label*="siguiente" i]');
    return byLabel && byLabel.getAttribute('href') ? byLabel.getAttribute('href') : null;
  }
 
  const hidePagination = (el) => { if (el) el.style.setProperty('display', 'none', 'important'); };
 
  function nearViewport(el) {
    if (!el) return false;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return el.getBoundingClientRect().top <= vh + TRIGGER_MARGIN;
  }
 
  function teardown() {
    if (observer) { observer.disconnect(); observer = null; }
    const s = container.querySelector('.' + SENTINEL_CLASS);
    if (s) s.remove();
  }
 
  function setup() {
    loading = false;
    lastUrl = null;
    teardown();
 
    const grid = getGrid();
    const nextUrl = getNextUrl();
    log('setup. grid?', !!grid, '| nextUrl:', nextUrl);
    if (!grid || !nextUrl) return;
 
    hidePagination(findPagination(container));
 
    const sentinel = document.createElement('div');
    sentinel.className = SENTINEL_CLASS;
    sentinel.setAttribute('role', 'status');
    sentinel.setAttribute('aria-live', 'polite');
    container.appendChild(sentinel);
 
    observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) loadNext(sentinel); }),
      { rootMargin: TRIGGER_MARGIN + 'px 0px' }
    );
    observer.observe(sentinel);
    maybeFill(sentinel);
  }
 
  function maybeFill(sentinel) {
    if (!loading && getNextUrl() && nearViewport(sentinel)) loadNext(sentinel);
  }
 
  function loadNext(sentinel) {
    const url = getNextUrl();
    if (loading || !url || url === lastUrl) { log('loadNext: saltado. loading', loading, '| url', url, '| lastUrl', lastUrl); return; }
    loading = true;
    lastUrl = url;
    sentinel.textContent = LOADING_LABEL;
    log('loadNext -> fetch', url);
 
    fetch(url)
      .then((r) => { log('respuesta', r.status, r.url); return r.text(); })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('product-grid');
        const grid = getGrid();
        let added = 0;
        if (newGrid && grid) {
          newGrid.querySelectorAll(':scope > li').forEach((li) => {
            grid.appendChild(document.importNode(li, true));
            added++;
          });
        }
        log('agregados', added, '| newGrid?', !!newGrid, '| totalEnGrid', grid ? grid.querySelectorAll(':scope > li').length : 'n/a');
 
        const currentPag = findPagination(container);
        const newPag = findPagination(doc);
        if (currentPag) {
          if (newPag) { hidePagination(newPag); currentPag.replaceWith(newPag); }
          else currentPag.remove();
        }
 
        loading = false;
        sentinel.textContent = '';
        const nextAfter = getNextUrl();
        log('nextAfter:', nextAfter);
 
        if (added === 0 || !nextAfter) { log('teardown (added', added, 'nextAfter', nextAfter, ')'); teardown(); }
        else maybeFill(sentinel);
      })
      .catch((e) => { err('fetch falló', e); loading = false; sentinel.textContent = ''; });
  }
 
  setup();
 
  new MutationObserver(() => {
    if (!container.querySelector('.' + SENTINEL_CLASS)) setup();
  }).observe(container, { childList: true, subtree: false });
})();
